// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCall_root__3Wve2"};